import { render, staticRenderFns } from "./projectModal.vue?vue&type=template&id=35b86f54&"
import script from "./projectModal.vue?vue&type=script&lang=ts&"
export * from "./projectModal.vue?vue&type=script&lang=ts&"
import style0 from "./projectModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports